import React from 'react';
import { Grid, Button, useTheme } from '@mui/material';
import { FILTER_OPTIONS } from '../constants/filters';

const FiltersPanel = ({ selectedFilter, onApply }) => {
  const theme = useTheme();
  return (
    <Grid container spacing={1} sx={{ p: 2 }}>
      {FILTER_OPTIONS.map((filter) => (
        <Grid item xs={12} key={filter.id}>
          <Button fullWidth variant={selectedFilter === filter.id ? 'contained' : 'outlined'} onClick={() => onApply(filter.id)} size="small" sx={{ color: theme.palette.text.primary, borderColor: theme.palette.divider, '&:hover': { borderColor: theme.palette.action.hover } }}>
            {filter.name}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default FiltersPanel;
